import React from 'react';

const ChefMarket = () => {
  return (
    <div>
      <h1>🎉 IT IS WORKING!</h1>
      <p>Chef Market component loaded successfully</p>
    </div>
  );
};

export default ChefMarket;
